import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-2 text-sm text-foreground-500 py-3 flex-wrap">
      {items.map((item, index) => (
        <span key={index} className="flex items-center gap-2">
          {index > 0 && (
            <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
          )}
          {item.to ? (
            <Link
              to={item.to}
              className="hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800 font-medium whitespace-nowrap">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}